/**
 * Language JSONs stored in https://s3.console.aws.amazon.com/s3/buckets/7gt-i18n-test-resource-bundle-localization?prefix=delivery/&region=us-east-1 with prefix "customer-app-web."
 */

import axios from 'axios'

import { REACT_APP_LOCALIZATION_BASE_PATH } from '../../config/environment'

export default async ({ component, app, platform, language }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: `${REACT_APP_LOCALIZATION_BASE_PATH}/${component}/${app}-${platform}.${language}`,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        return res.data.data
    } catch (error) {
        console.error('Failed to retrieve language data:', error?.message || error)
        return null
    }
}
